// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f9a81004","356":"422548c8","438":"2092d29a","465":"7ce19150","538":"37eb6758","912":"d501b501","954":"e0310521"}[chunkId] + ".chunk.js";
};